module.exports = __webpack_public_path__ + "img/SolV.380aa7a4.png";